import { useFormContext } from 'react-hook-form';
import { DonateButtonFormData } from '../../../types/givingCheckoutForm';
import { getColourContrast } from '../../utils/getColourContrast';

const useButtonColor = () => {
  const { watch } = useFormContext<DonateButtonFormData>();
  const buttonColor = watch('buttonColor');

  const contrast = getColourContrast(buttonColor || null);
  const isLowContrast = Boolean(contrast && contrast > 175);

  const textColor = isLowContrast ? '#000' : '#fff';

  return { buttonColor, textColor };
};

export default useButtonColor;
